import { render, staticRenderFns } from "./ConsultingItem.vue?vue&type=template&id=408aec42&scoped=true"
import script from "./ConsultingItem.vue?vue&type=script&lang=js"
export * from "./ConsultingItem.vue?vue&type=script&lang=js"
import style0 from "@styles/other/home/homeHotwords.css?vue&type=style&index=0&id=408aec42&prod&scoped=true&lang=css&external"
import style1 from "./ConsultingItem.vue?vue&type=style&index=1&id=408aec42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408aec42",
  null
  
)

export default component.exports